module.exports = __webpack_public_path__ + "files/SPIADI2023 - Rapport annuel d'activité.bceb590133c0807d0e87b4638e469f2d.pdf";